import apiService from '../utils/apiService';
import { channelActions } from '../reducers/channel';
import { createNotification } from '../utils';
import { notificationType } from '../constants/globals';
import {
    channelPath,
    channelIdPath,
    channelPageablePath   
} from '../constants/apiEndpoints';
import { errorAction, tokenExpiredAction } from '../utils/actions';

export const fetchAllChannels = () => {
  return (dispatch) => {
    dispatch(channelActions.actionStart());
    return apiService
      .get(channelPageablePath())
      .then((response) => {          
        dispatch(channelActions.fetchAllChannelsPageable(response.data));
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          tokenExpiredAction();
        } else dispatch(channelActions.actionError(err?.response?.data));
      });
  };
};

export const fetchAllChannelsPageable = (pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(channelActions.actionStart());
    return apiService
      .get(channelPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(channelActions.fetchAllChannelsPageable(response.data));       
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          tokenExpiredAction();
        } else dispatch(channelActions.actionError(err?.response?.data));
      });
  };
};

export const deleteChannel = (id, messages, activePage, pageSize) => {
  return (dispatch) => {
    dispatch(channelActions.actionStart());
    return apiService
      .delete(channelIdPath(id))
      .then(() => {
        dispatch(channelActions.deleteChannel(id));
        dispatch(fetchAllChannelsPageable(activePage, pageSize));
      })
      .then(() => {
        createNotification(
          notificationType.success,
          messages?.title,
          messages?.successDelete
        );  
      })
      .catch((err) => {
        errorAction(err, channelActions.actionError, dispatch, messages);
      });
  };
};

export const deleteErrorChannel = () => {
  return (dispatch) => {
    dispatch(channelActions.clearError());
  };
};

export const updateChannel = (channel, callback, messages) => {
  return (dispatch) => {
    dispatch(channelActions.actionStart());
    return apiService
      .put(channelPath(), channel)
      .then((response) => {
        dispatch(channelActions.updateChannel(response.data));
        createNotification(
          notificationType.success,
          messages?.title,
          messages?.successUpdate
        );
        callback();
      })
      .catch((err) => {
        errorAction(err, channelActions.actionError, dispatch, messages);
      });
  };
};

export const createChannel = (channel, callback, messages, pageSize) => {
  return (dispatch) => {
    dispatch(channelActions.actionStart());
    return apiService
      .post(channelPath(), channel)
      .then((response) => {
        dispatch(channelActions.addChannel(response.data));
        callback();
        dispatch(fetchAllChannelsPageable(0, pageSize));
      })
      .then(() => {
        createNotification(
          notificationType.success,
          messages?.title,
          messages?.successCreation      
        );
      })
      .catch((err) => {     
        errorAction(err, channelActions.actionError, dispatch, messages);
      });
  };
};
